import { render } from "./ProfilePage.vue?vue&type=template&id=24705023"
import script from "./ProfilePage.vue?vue&type=script&lang=js"
export * from "./ProfilePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__